/**
 * Represents a single order line in a Backstage order.
 * Note: `productId` refers to the variant EAN/barcode, not the product group number.
 */
export class OrderLineModel {
  /** Variant identifier (EAN/barcode), not the product group number */
  public productId: string;
  public name: string;
  public description: string;
  public unitPrice: number;
  public quantity: number;
  public totalPrice: number;
  public dueDate?: string | Date;
  public orderLineNumber: string;
  public lineItemNumber: number;
  public unitDiscount: number;
  public productColorId: string;
  public productSizeId: string;
  public locationId: string;
  public unitOfMeasure: string;
  public receiptRequestedDate: string | Date;
  public receiptConfirmedDate: string | Date;
  public lineStatus: string;
  public addressName: string;
  public address: string;
  public inventoryTransactionNumber?: string;
  public productGroupName?: string;
  public quantityCancelled: number;
  public quantityShipped: number;
  public quantityUpdated?: number;
  public launchDate?: string | Date;
  public customerName?: string;

  // @deprecated
  public externalId?: string;
  // @deprecated
  public id?: string;
}
